import { Navigate } from "react-router-dom";
import QualificationList from "../components/qualificationList";
import QualificationCreate from "../components/qualificationCreate";
import QualificationEditView from "../components/qualificationEditView";
import SvgIcons from "../../../../shared/components/svgIcons";
const qualificationRoute = {
  icon: SvgIcons.MasterDataIcon,
  name: "Master Data",
  link: "/master-datas",
  path: "/master-datas",
  element: "",
  index: 990,
  children: [
    {
      path: "qualifications",
      element: <QualificationList />,
      name: "Qualifications",
      permission: "Qualification",
      index: 4,
      link: "master-datas/qualifications",
      icon: SvgIcons.QualificationsIcon,
    },
    {
      path: "qualifications/create",
      element: <QualificationCreate />,
    },
    {
      path: "qualifications/:id",
      element: <QualificationEditView />,
    },
    {
      path: "",
      element: <Navigate to="master-datas/qualifications" replace />,
    },
  ],
};
export default qualificationRoute;
